var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-bar chart-container absolute top-0 right-0 bg-white p-3 z-1000",attrs:{"id":"info-pane"}},[_c('scatter-chart',{staticClass:"w-64 h-48",attrs:{"data":_vm.initial,"library":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }